(() => {
  if (window.HACompleteTheFit) return;
  window.HACompleteTheFit = true;

  function updateStatus(card, message) {
    const status = card?.querySelector('[data-ha-complete-fit-status]');
    if (status) status.textContent = message;
  }

  function updateBundleStatus(root, message) {
    const status = root?.querySelector('[data-ha-complete-fit-bundle-status]');
    if (status) status.textContent = message;
  }

  function setButtonState(button, state) {
    button.classList.toggle('is-loading', state === 'loading');
    button.classList.toggle('is-added', state === 'added');

    if (state === 'loading') {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  function syncCartState(cart, response) {
    if (!cart || cart.tagName !== 'CART-DRAWER') return;

    const itemCount = typeof response.item_count === 'number' ? response.item_count : response.items?.length || 1;
    const isEmpty = itemCount === 0;

    cart.classList.toggle('is-empty', isEmpty);
    cart.querySelector('cart-drawer-items')?.classList.toggle('is-empty', isEmpty);
    cart.querySelector('.drawer__inner')?.classList.toggle('is-empty', isEmpty);
  }

  function addVariantById({ sourceButton, variantId, productTitle, variantTitle = '', properties = null, statusMessage = '' }) {
    const card = sourceButton?.closest('[data-ha-complete-fit-card]');
    const root = sourceButton?.closest('[data-ha-complete-fit-root]');
    if (!sourceButton || sourceButton.disabled || sourceButton.classList.contains('is-loading')) return Promise.resolve();

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (properties) {
      Object.entries(properties).forEach(([key, value]) => {
        formData.append(`properties[${key}]`, value);
      });
    }

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(sourceButton);
    }

    config.body = formData;

    setButtonState(sourceButton, 'loading');
    if (card) {
      updateStatus(card, statusMessage || `Adding ${variantTitle}...`);
    }
    if (root) {
      updateBundleStatus(root, statusMessage || '');
    }

    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || 'Unable to add this item right now.');
        }

        syncCartState(cart, response);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ha-complete-the-fit',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        cart.renderContents(response);
        setButtonState(sourceButton, 'added');
        if (card) {
          updateStatus(card, `${productTitle}${variantTitle ? ` ${variantTitle}` : ''} added to bag.`);
        }
        if (root) {
          const role = sourceButton.dataset.haCompleteFitRole;
          if (role === 'jacket' || role === 'thermal') {
            updateBundleStatus(root, 'Complete the fit applied will be added automatically when both a core jacket and thermal are in the bag.');
          }
        }

        window.setTimeout(() => {
          sourceButton.classList.remove('is-added');
        }, 1600);
      })
      .catch((error) => {
        console.error(error);
        if (card) {
          updateStatus(card, error.message || 'Unable to add this item right now.');
        }
        if (root) {
          updateBundleStatus(root, error.message || 'Unable to add this bundle right now.');
        }
      })
      .finally(() => {
        setButtonState(sourceButton, sourceButton.classList.contains('is-added') ? 'added' : 'idle');
      });
  }

  function addVariant(button) {
    return addVariantById({
      sourceButton: button,
      variantId: button.dataset.haCompleteFitVariantId,
      productTitle: button.dataset.haCompleteFitProductTitle || 'Item',
      variantTitle: button.dataset.haCompleteFitVariantTitle || '',
    });
  }

  document.addEventListener('click', (event) => {
    const scrollTrigger = event.target.closest('[data-ha-complete-fit-scroll]');
    if (scrollTrigger) {
      event.preventDefault();
      const target = document.getElementById(scrollTrigger.dataset.haCompleteFitScroll);
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const sizeButton = event.target.closest('[data-ha-complete-fit-variant-id]');
    if (sizeButton) {
      event.preventDefault();
      addVariant(sizeButton);
    }
  });
})();
